import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); }
    catch (err) { console.warn("Logout request failed (continuing client-side cleanup):", err); }
    setUser(null);
    window.location.href = "/";
  };

  const setRole = async (role, institution_type) => {
    const { data } = await api.post("/auth/role", { role, institution_type });
    setUser(data);
    return data;
  };

  const setInstitution = async (institution_type) => {
    const { data } = await api.post("/auth/institution", { role: user?.role || "admin", institution_type });
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, setUser, checkAuth, logout, setRole, setInstitution }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
